export const LocationType = {
  Cache: 'cache',
  Geo: 'geo',
  Alt: 'alt',
  Unknown: 'unknown',
}
